import { render } from "./App.vue?vue&type=template&id=82e10a5e&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=82e10a5e&lang=css"

import exportComponent from "/home/runner/work/ticketcafe-widget/ticketcafe-widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__